import { ArrowDown } from "@expert/common-ui/assets/ArrowDown";
import { Button, Group } from "@mantine/core";
import classes from "./message-component-styles.module.css";
import { type ScrollAreaViewport, scrollToBottom } from "./scrollUtils";

export const NewMessagesScrollButton = ({
    unreadCount,
    viewport,
    scrolledToBottom,
}: {
    scrolledToBottom: boolean;
    unreadCount: number;
    viewport: ScrollAreaViewport;
}) => {
    if (scrolledToBottom || !unreadCount) return null;
    return (
        <Group justify="center" pos="absolute" left="0" right="0" bottom="var(--mantine-spacing-lg)">
            <Button
                classNames={{
                    root: classes.new_message_button,
                    label: classes.new_message_button_label,
                    section: classes.new_message_button_section,
                }}
                size="md"
                variant="filled"
                color="dark.7"
                leftSection={unreadCount.toString()}
                rightSection={<ArrowDown />}
                onClick={() => scrollToBottom(viewport)}
            >
                {`New message${unreadCount > 1 ? "s" : ""}`}
            </Button>
        </Group>
    );
};
